/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import SurveyBasedComponent from "parog-web/components/forc/abstract/survey-based-component";

import styles from "./index.module.css";

export default class PersonalBackgroundFormComponent extends SurveyBasedComponent {
  styles = styles;

  static forcDisplayName = "Antécédents personnels et familiaux";
  static fullComponentId = "personal-background/form";

  computePayload() {
    const payload = super.computePayload();

    if (payload.definitiveContraception !== "no") {
      delete payload.contraceptionMethod;
    }

    return payload;
  }
}
